'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash.get');
const css = require('./personalizationStyle.scss');
const MediaQuery = require('../../../global/components/MediaQuery');
const strings = require('dibs-strings-helper');
const {queries} = require('../../../global/core/commonjs/screenSize');
const tracking = require('../../helpers/tracking.es');

function onItemClick(item, trackingObj) {
    tracking.trackPersonalizationPromoClick();
    tracking.trackPersonalizationItemClick(item, trackingObj);
}

function PersonalizationPanelItem(props) {
    const url = get(props.item, 'pdpUrls[0]');
    const image = get(props.item, 'images[0].thumb');
    const shortTitle = strings.clampWithEllipsis(props.item.title, 45);
    const trackingObj = {
        variant: props.variant,
        category: props.categoryUrl,
        position: props.index
    };

    return (
        <a key={props.item.id} href={url} onClick={() => onItemClick(props.item, trackingObj)} className={`colXs4 colXl5 ${css.smallItemWrapper}`}>
            <div className={css.itemContainer}>
                <img alt={props.item.title} className={css.smallItemImage} src={image} />
            </div>
            <MediaQuery query={[queries.md, queries.lg, queries.xl]}>
                <div className={css.itemTitle}>{shortTitle}</div>
            </MediaQuery>
        </a>
    );
}

PersonalizationPanelItem.propTypes = {
    item: PropTypes.object.isRequired,
    variant: PropTypes.string.isRequired,
    categoryUrl: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired
};

module.exports = PersonalizationPanelItem;



// WEBPACK FOOTER //
// ./assets/js/home/components/personalization/PersonalizationPanelItem.jsx